import React from 'react';
import Button from '@material-ui/core/Button';
import { useButtonStyles } from './buttons.style';
import { CustomButtonProps } from './Buttons';

const SecondaryButton = (props: CustomButtonProps) => {
  const classes = useButtonStyles(props);
  const { isLoading, onClick, disabled, borderColor, ...rest } = props;
  if (isLoading) return <>En chargement...</>;

  return (
    <Button
      disabled={disabled}
      className={classes.secondaryButton}
      onClick={onClick}
      {...rest}
    >
      {props.children}
    </Button>
  );
};

export default SecondaryButton;
